<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-space-between align-center mb-7">
      <div>
        <div style="font-size: 30px; font-weight: 800; color: #111827; letter-spacing: -0.5px; line-height: 1.2">
          OJT Instructors
        </div>
        <div class="mt-1" style="font-size: 14px; color: #6b7280">
          Manage OJT instructors and their program assignments
        </div>
      </div>
      <div class="d-flex align-center ga-3">
        <v-text-field
          v-model="search"
          placeholder="Search..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          hide-details
          clearable
          style="max-width: 220px"
        />
        <v-btn
          color="#00A63E"
          variant="flat"
          class="text-white"
          @click="addnew"
          prepend-icon="mdi-plus"
          rounded="lg"
          size="large"
        >
          Add New
        </v-btn>
      </div>
    </div>

    <!-- Data Table -->
    <v-card flat class="rounded-xl table-card">
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :loading="loading"
        hover
        class="rounded-xl"
      >
        <template v-slot:[`item.programs_assigned`]="{ item }">
          <v-chip
            class="d-flex justify-center my-2"
            size="small"
            v-for="(it, i) in item.programs_assigned"
            :key="i"
            >{{ it }}</v-chip
          >
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <!-- <v-tooltip text="View Weights" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="primary"
                variant="text"
                v-bind="props"
                @click="viewItem(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
          </v-tooltip> -->
          <v-tooltip text="Edit data" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="primary"
                variant="text"
                v-bind="props"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-tooltip>

          <!-- <v-tooltip text="Update Credentials" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="primary"
                variant="text"
                v-bind="props"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-tooltip> -->

          <!-- <v-tooltip text="Delete" location="top">
            <template #activator="{ props }">
              <v-btn
                icon
                color="error"
                variant="text"
                v-bind="props"
                @click="deleteItem(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-tooltip> -->
        </template>

        <template #no-data>
          <i>No data found.</i>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialogs -->
    <OjtInstructorDialog :data="itemData" :action="action" />
    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import OjtInstructorDialog from "../Dialogs/Forms/Users/OjtInstructorDialog.vue";
export default {
  components: {
    OjtInstructorDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",
    headers: [
      { title: "Name", value: "name", align: "start" },
      {
        title: "Program Assigned",
        value: "programs_assigned",
        align: "center",
      },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    totalCount: 0,
    deleteData: null,
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();
    eventBus.on("closeOjtInstructorDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeOjtInstructorDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.loading = true;
      this.axiosCall("/user-details/getOjtInstructors", "GET").then((res) => {
        if (res) {
          this.data = res.data;
          this.loading = false;
        }
      });
    },
    addnew() {
      this.itemData = [{ id: null }];
      this.action = "Add";
    },
    deleteItem(item) {
      console.log(item);
      this.alerted = true;
      // this.dialogConfirmDelete = true;
      // this.deleteData = item;
    },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    viewItem() {},
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>

<style scoped>
.table-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
</style>
